import * as React from 'react';
import { Divider, Stack, Typography } from '@mui/material';

export default function TableToolbar({ title, subtitle, actions, sx }) {
  return (
    <Stack spacing={1} sx={{ mb: 1.5, ...sx }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
        <Stack spacing={0.25}>
          <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          ) : null}
        </Stack>
        {actions ? <Stack direction="row" spacing={1.25}>{actions}</Stack> : null}
      </Stack>
      <Divider />
    </Stack>
  );
}




